import React from 'react'
import styled from 'styled-components'
import { propOr } from 'ramda'
import RestoreTeacherModal from 'modules/archivedTeachers/components/RestoreTeacherModal'

const ArchivedTeachersTableRow = ({ teacher, order }) => {
  return (
    <Wrapper>
      <td>{order}.</td>
      <td>{propOr('---', 'name', teacher)}</td>
      <td>{propOr('---', 'email', teacher)}</td>
      <td>{propOr('---', 'phoneNumber', teacher)}</td>
      <td>
        <Actions onClick={e => e.stopPropagation()}>
          <RestoreTeacherModal teacher={teacher} />
        </Actions>
      </td>
    </Wrapper>
  )
}

export default ArchivedTeachersTableRow

const Wrapper = styled.tr`
  transition: all .3s;
  font-size: 14px;
  
  &:hover {
    background-color: ${({ theme }) => theme.colors.lightGrey};
    cursor: pointer;
  }
`

const Actions = styled.div`
  text-align: right;
  display: flex;
  justify-content: flex-end;
  align-items: center;
  gap: 10px;
`
